import { cgwClient } from '../cgwClient'
import {
  SafesGetSafeOverviewV1ApiArg,
  SafesGetSafeOverviewV1ApiResponse,
  SafesGetSafeOverviewV2ApiArg,
  SafesGetSafeOverviewV2ApiResponse,
} from '../AUTO_GENERATED/safes'
import { addTagTypes } from '../AUTO_GENERATED/safes'

function chunkArray<T>(array: T[], size: number): T[][] {
  const chunks: T[][] = []
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size))
  }
  return chunks
}

const MAX_SAFES_PER_REQUEST = 10

// V1 endpoint (default - used by mobile)
export const additionalSafesRtkApi = cgwClient
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      safesGetOverviewForMany: build.query<
        SafesGetSafeOverviewV1ApiResponse,
        Omit<SafesGetSafeOverviewV1ApiArg, 'safes'> & { safes: string[] }
      >({
        async queryFn(args, _api, _extraOptions, fetchWithBaseQuery) {
          const { safes, currency, trusted, excludeSpam, walletAddress } = args
          const chunkedSafes = chunkArray(safes, MAX_SAFES_PER_REQUEST)

          let combinedData: SafesGetSafeOverviewV1ApiResponse = []

          // Fetch each chunk
          for (const chunk of chunkedSafes) {
            const chunkArg: SafesGetSafeOverviewV1ApiArg = {
              currency,
              safes: chunk.join(','), // convert the chunk back to comma-separated
              trusted,
              excludeSpam,
              walletAddress,
            }

            // Call the v1 endpoint
            const result = await fetchWithBaseQuery({
              url: '/v1/safes',
              params: {
                currency: chunkArg.currency,
                safes: chunkArg.safes,
                trusted: chunkArg.trusted,
                exclude_spam: chunkArg.excludeSpam,
                wallet_address: chunkArg.walletAddress,
              },
            })

            if (result.error) {
              return { error: result.error }
            }

            combinedData = combinedData.concat(result.data as SafesGetSafeOverviewV1ApiResponse)
          }

          return { data: combinedData }
        },
        providesTags: ['safes'],
      }),
    }),
    overrideExisting: true,
  })

// V2 endpoint (used by web app when PORTFOLIO_ENDPOINT feature flag is enabled)
export const additionalSafesRtkApiV2 = cgwClient
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      safesGetOverviewForManyV2: build.query<
        SafesGetSafeOverviewV2ApiResponse,
        Omit<SafesGetSafeOverviewV2ApiArg, 'safes'> & { safes: string[] }
      >({
        async queryFn(args, _api, _extraOptions, fetchWithBaseQuery) {
          const { safes, currency, trusted, walletAddress } = args
          const chunkedSafes = chunkArray(safes, MAX_SAFES_PER_REQUEST)

          let combinedData: SafesGetSafeOverviewV2ApiResponse = []

          // Fetch each chunk
          for (const chunk of chunkedSafes) {
            const chunkArg: SafesGetSafeOverviewV2ApiArg = {
              currency,
              safes: chunk.join(','), // convert the chunk back to comma-separated
              trusted,
              walletAddress,
            }

            // Call the v2 endpoint
            const result = await fetchWithBaseQuery({
              url: '/v2/safes',
              params: {
                currency: chunkArg.currency,
                safes: chunkArg.safes,
                trusted: chunkArg.trusted,
                wallet_address: chunkArg.walletAddress,
              },
            })

            if (result.error) {
              return { error: result.error }
            }

            combinedData = combinedData.concat(result.data as SafesGetSafeOverviewV2ApiResponse)
          }

          return { data: combinedData }
        },
        providesTags: ['safes'],
      }),
    }),
    overrideExisting: true,
  })

export const { useSafesGetOverviewForManyQuery, useLazySafesGetOverviewForManyQuery } = additionalSafesRtkApi
export const { useSafesGetOverviewForManyV2Query, useLazySafesGetOverviewForManyV2Query } = additionalSafesRtkApiV2
